import React, { useEffect, useState } from "react";
import { Table, Switch, Image, message, Button, Pagination, Modal, Space } from "antd";
import { customerBannerService } from "../../../services";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import CustomerBannerForm from "./CustomerBanner";

function CustomerBanners() {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });
    const [modalShow, setModalShow] = useState(false)
    const [selectedDeleteRecord, setSelectedDeleteRecord] = useState(null);
    const [deleteLoading, setDeleteLoading] = useState(false)

    const [formModal, setFormModal] = useState(false)
    const [recordForm, setRecordForm] = useState(null)

    const fetchData = async (page = 1, perPage = 10) => {
        setLoading(true);
        const res = await customerBannerService.fetch(page, perPage);
        setLoading(false);
        const banners = res.data.data;
        setData(banners);
        setPagination({
            current: res.data.current_page,
            pageSize: res.data.per_page,
            total: res.data.total,
        });
    };

    const handleDelete = async () => {
        setDeleteLoading(true)
        if (!selectedDeleteRecord.id) return;
        const response = await customerBannerService.delete(selectedDeleteRecord.id);
        setDeleteLoading(false)
        if (response.success) {
            setData((prevData) =>
                prevData.filter((item) => item.id !== selectedDeleteRecord.id)
            );
            fetchData();
        }
        setModalShow(false);
    };

    const handleStatusChange = async (checked, record) => {

        const previousStatus = record.is_active;
        setData(prev => prev.map(item => item.id === record.id ? { ...item, is_active: checked ? 1 : 0 } : item));

        try {
            await customerBannerService.status(record.id);
            message.success("Status updated");
        } catch (err) {
            setData(prev => prev.map(item => item.id === record.id ? { ...item, is_active: previousStatus } : item));
            message.error("Failed to update status");
        }
    };

    const renderDeleteModal = (
        <Modal
            title={<div style={{ textAlign: "center" }}>Confirm</div>}
            open={modalShow}
            onCancel={() => setModalShow(false)}
            centered
            styles={{
                body: {
                    padding: "20px",
                },
            }}
            width={300}
            footer={
                <div className="flex justify-center gap-3">
                    <Button
                        type="default"
                        onClick={() => setModalShow(false)}
                        style={{ width: "30%" }}
                    >
                        Cancel
                    </Button>
                    <Button
                        type="primary"
                        onClick={handleDelete}
                        loading={deleteLoading}
                        style={{ width: "30%" }}
                    >
                        Confirm
                    </Button>
                </div>
            }
        >
            <p style={{ textAlign: "center" }}>
                Are you sure you want to delete this?
            </p>
        </Modal>
    );

    const columns = [
        {
            title: "ID",
            dataIndex: "id",
            key: "id",
        },
        {
            title: "Banner",
            dataIndex: "url",
            key: "url",
            render: (url) => (
                <Image
                    src={url}
                    width={120}
                    height={60}
                    style={{ objectFit: "cover" }}
                />
            ),
        },
        {
            title: "Status",
            dataIndex: "is_active",
            key: "is_active",
            render: (is_active, record) => (
                <Switch
                    checked={is_active === 1}
                    checkedChildren="Active"
                    unCheckedChildren="Inactive"
                    onChange={(checked) =>
                        handleStatusChange(checked, record)
                    }
                />
            ),
        },
        {
            title: "Created At",
            dataIndex: "created_at",
            key: "created_at",
            render: (text) => dayjs(text).format("YYYY-MM-DD")
        },
        {
            title: "Action",
            dataIndex: "action",
            key: "action",
            render: (_, record) => (
                <Space size="small">
                    <EditOutlined onClick={() => {
                        setFormModal(true)
                        setRecordForm(record)
                    }} />

                    <DeleteOutlined onClick={() => {
                        setSelectedDeleteRecord(record);
                        setModalShow(true);
                    }} />
                </Space>

            )
        }
    ];

    useEffect(() => {
        fetchData();
    }, [])

    return (
        <div style={{ padding: "5px", border: "1px solid #ccc", borderRadius: "8px", backgroundColor: "#FFFFFF" }}>
            <div className="flex justify-between my-3">
                <h1 style={{ fontWeight: "bold" }} className="pl-2 pt-3">Browse Customer Banner</h1>
                {/* <Link to={"/operations/customer/banner/form"}> */}
                <Button type="primary" onClick={() => {
                    setRecordForm(null)
                    setFormModal(true)
                }}>Add Customer Banner</Button>
                {/* </Link> */}
            </div>

            <Table
                rowKey="id"
                columns={columns}
                dataSource={data}
                loading={loading}
                pagination={false}
                style={{ marginTop: "10px" }}
                footer={() => (
                    <div className="flex justify-between items-center text-xs ">
                        <div className=" text-gray-600">
                            Showing {(pagination.current - 1) * pagination.pageSize + 1} to{" "}
                            {Math.min(pagination.current * pagination.pageSize, pagination.total)} of{" "}
                            {pagination.total} entries
                        </div>
                        <Pagination
                            current={pagination.current}
                            total={pagination.total}
                            pageSize={pagination.pageSize}
                            showSizeChanger={false}
                            onChange={(page) => fetchData(page, pagination.pageSize)}
                            itemRender={(current, type, originalElement) => {
                                if (type === "prev") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Previous</a>;
                                if (type === "next") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Next</a>;
                                return originalElement;
                            }}
                        />

                    </div>
                )}
            />

            <CustomerBannerForm
                formModal={formModal}
                setFormModal={setFormModal}
                recordForm={recordForm}
                onSuccess={fetchData}
            />
            {renderDeleteModal}
        </div>
    );
}

export default CustomerBanners;
